var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3042 0.147351C10.545 0.361386 10.5667 0.730095 10.3527 0.970885L4.13044 7.97088C4.01974 8.09542 3.86107 8.16667 3.69445 8.16667C3.52783 8.16667 3.36916 8.09542 3.25846 7.97088L0.147351 4.47088C-0.0666847 4.23009 -0.044996 3.86139 0.195794 3.64735C0.436584 3.43332 0.805293 3.455 1.01933 3.69579L3.69445 6.70531L9.48068 0.195794C9.69472 -0.044996 10.0634 -0.0666847 10.3042 0.147351Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.2f781536883396dbc056a0e8d50410c7.svg";
export { ForwardRef as ReactComponent };